import gql from 'graphql-tag';

const PassengerTicketsConnection = gql`
  query PassengerTicketsConnection($filter: PassengerTicketFilter!, $after: String, $before: String, $first: Int, $last: Int, $orderBy: [[String]]) {
    passengerTicketsConnection(filter: $filter, after: $after, before: $before, first: $first, last: $last,orderBy: $orderBy) {
      totalCount
       pageInfo {
         startCursor
         endCursor
         hasNextPage
         hasPreviousPage
       }
      edges {
        cursor
        node {
          id
          number
          passengerLastName
          passengerFirstName
          departureDate
          airlineNames
          pnr
          affiliate {
            id
            name
          }
          flightsPassengerTicketsConnection {
            edges {
              cursor
              node {
                id
                flight {
                  id
                  flightNumber
                }
              }
            }
          }
        }
      }
    }
  }
`

export { PassengerTicketsConnection }



// WEBPACK FOOTER //
// ./src/queries/PassengerTicketsConnection.js